import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { MasterKushStrainIndexCardStackBackgroundViewModel } from './master-kush-strain-index-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';

@Component({
  selector: 'app-master-kush-strain-index-card-stack-background',
  templateUrl: './master-kush-strain-index-card-stack-background.component.html',
  styleUrls: ['./master-kush-strain-index-card-stack-background.component.scss'],
  providers: [MasterKushStrainIndexCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MasterKushStrainIndexCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: MasterKushStrainIndexCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
